<template>
  <div :class="classes" v-loading.lock="loading" element-loading-text="正在处理中，请稍后">
    <pt-form-item label="上传委托单Excel或Zip文件：" :required="true" labelWidth="200px">
      <!-- 上传组件 -->
      <el-upload ref="excel" class="upload-demo" action="aa" :auto-upload="false" :multiple="false" :on-change="changHandler" :on-remove="removeHandler" :file-list="excel" v-model="lotForm.excel" name="excel" v-validate="'required'" data-vv-as="上传文件">
        <el-button size="small" type="primary">点击上传</el-button>
        <!-- <a style="margin-left:10px" :href="$privateResourcesUrlDownload + tenant+ '/templates/委托单创建模板.xlsx'"> -->
          <el-button type="text" @click="downloadTemplate">下载委托单Excel模版</el-button>
        <!-- </a> -->
        <br>
      </el-upload>
    </pt-form-item>
		<pt-form-item label="是否显示全部样品名称：" labelWidth="200px" :required="true">
			<el-radio-group data-vv-as="是否显示全部样品名称" v-validate="'required'" v-model="lotForm.isDisplayAll">
				<el-radio label="true">是</el-radio>
				<el-radio label="false">否</el-radio>
			</el-radio-group>
		</pt-form-item>
    <pt-form-item label="快递单号：" labelWidth="200px">
      <div v-for="(item,i) in lotForm.courierNumber" :key="i">
        <el-input placeholder="请填写快递单号" v-model="item.value" :class="'courier_'+i"></el-input>
        <el-button style="margin-left:10px" type="text" @click="deleteItem(i)">删除</el-button><br>
        <el-button type="text" @click="addItem(i)" v-show="i==lotForm.courierNumber.length-1">添加一条</el-button>
      </div>
    </pt-form-item>
    <pt-form-item label="所属科室：" labelWidth="200px" :required="true">
      <wt-selector data-vv-as="所属科室" v-validate="'required'" v-model="lotForm.departmentName" :options="departementList" :allowCreate="true" placeholder="请选择所属科室"></wt-selector>
    </pt-form-item>

    <slot />
  </div>
</template>

<script>
import formMixins from 'mixins/form'
// 组件class前缀
import organizationSelector from 'cps/selector/organization-selector'
import {
  departementList
} from 'json/lab-order'
// import { handleWorkFlow } from 'cps/lab-order/pt-lab-order-form/form-required-option'
const prefixCls = 'pt-business-order-lot-form'

export default {
  name: 'pt-business-order-lot-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tenant () {
      console.log('this.$store.state.saasConfig==', this.$store.state.saasConfig)
      return this.$store.state.saasConfig.tenant
    },
    focusView () {
      return this.$store.state.saasConfig.focusView
    }
  },
  data () {
    return {
      departementList,
      lotForm: {
        clientOrganizationId: '',
        remark: '',
        sender: '',
        courierNumber: [{ value: '' }],
        excel: []
      },
      excel: [],
      uploadForm: new FormData(),
      loading: false,
      contractId: [],
      workflow: ''
    }
  },
  components: {
    organizationSelector
  },
  props: {
    contractList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    'lotForm.clientOrganizationId' (val) {
      if (val) {
        this.contractId = []
      }
    }
  },
  methods: {
		downloadTemplate(){
			location.href = `${this.$privateResourcesUrlDownload}${this.tenant}/templates/委托单创建模板.xlsx`
		},
    handleEdit (index, val) {
      this.$router.push(`./product-contract-detail/${val.id}`)
    },
    handleDelete (index, val) {
      this.contractId.splice(index, 1)
    },
    closeDialog () {
      this.isDialogShow = false
    },
    selectData (val) {
      this.closeDialog()
      console.log('----selectData----', val)
      this.contractId = val
    },
    selectContract () {
      this.isDialogShow = true
    },
    changeOgz () {

    },
    downLoadFile () {
      // this.$privateResourcesUrlDownload()rawdata/0001/sample_FinalReport_0001.txt
    },
    addItem (index) {
      if (this.lotForm.courierNumber[index].value === '') {
        this.$message.error('请填写快递单号！')
        return
      }
      this.lotForm.courierNumber.push({ value: '' })
      this.$nextTick(() => {
        document.querySelector('.courier_' + (index + 1) + '>input').focus()
      })
    },
    deleteItem (index) {
      if (index === 0 && this.lotForm.courierNumber.length === 1) {
        this.$message.error('不能再删除了')
        return
      }
      this.$confirm('确定要删除该条快递吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.lotForm.courierNumber.splice(index, 1)
      })
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    removeHandler (file, fileList) {
      this.excel = fileList
      this.lotForm.excel = fileList
    },
    getNumber (arr) {
      var newArr = []
      arr.forEach(element => {
        if (element.value) {
          newArr.push(element.value)
        }
      })
      return newArr
    },
    async submit () {
      this.loading = true
      this.uploadForm = new FormData()
      this.uploadForm.append('excel', this.excel[0].raw)
      // 不同视角使用不同的workflow
      // let workflow = this.workflow
      let workflow = 'LAB_BILL_CREATED'
      let fileUrl = await this.$store.dispatch('uploadTempFile', { file: this.excel[0].raw, batchNumber: 'bill' })
      this.uploadForm.append('workflow', workflow)

      this.uploadForm.append('expressNumber', this.lotForm.courierNumber ? this.lotForm.courierNumber.map(e => e.value) : '')
      this.uploadForm.append('fileUrl', fileUrl.data)
      this.uploadForm.append('asyncImport', true)
      this.uploadForm.append('departmentName', this.lotForm.departmentName)
			this.uploadForm.append('isDisplayAll',((this.lotForm.isDisplayAll==='true'||this.lotForm.isDisplayAll==='false')?eval(this.lotForm.isDisplayAll.toLowerCase()):this.lotForm.isDisplayAll))
      this.$store.dispatch('createBatchBill', this.uploadForm).then(res => {
        let data = res.data
          if (data?.length) {
            let successJobRecord= data.filter(item => {
              return item.result?.jobRecord?.id
            })
            let errorMessages= data.map(item => {
              return item?.errorMessage
            }).filter(item => item)
            let jobRecordIds= data.map(item => {
              return item.result?.jobRecord?.id
            }).filter(item => item)
            if (errorMessages?.length) {
              this.$emit('errorMsg', errorMessages)
            }
            if (jobRecordIds?.length) {
              this.getSamplesjobRecords(jobRecordIds)
            } else {
              this.loading=false
            }
          }
      }).catch((error) => {
        console.log('error===', error)
        this.loading = false
        this.lotForm.excel[0].status = 'ready'
        this.excel[0] = this.lotForm.excel[0]
        this.$message.error(error)
        this.$emit('errorMsg')
      })
    },
    getOrderWorkFlow () {
      this.$store.dispatch('getOrderWorkFlow').then(res => {
        this.workflow = res
      })
    },
    getSamplesjobRecords (data) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getSamplesjobRecords', data).then(res => {
          // if()
          let processingData = res.filter(item => {
            return item.status === 'PROCESSING'
          });
          let failedData = res.filter(item => {
            return item.status === 'FAILED'
          });
          let unknownData = res.filter(item => {
            return item.status === 'UNKNOWN'
          });
          let completedData = res.filter(item => {
            return item.status === 'COMPLETED'
          });
          if (processingData.length) {
            resolve(setTimeout(() => {
              this.getSamplesjobRecords(data)
            }, 5000))
          } else if (failedData.length) {
            this.loading = false
            let errorMessages =''
            failedData.forEach(item => {
              errorMessages= errorMessages? (errorMessages+ '<br/>' +`${item.filename}有${item.countFailed}条委托单导入失败,`): `${item.filename}有${item.countFailed}条委托单导入失败,`
            })
            this.$alert(`${errorMessages}<br/>请在异常委托单中查看详情`, '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              callback: action => {
                if (this.$route.query.isSamplePlate) {
                  this.$router.push({ name: 'sample-board-list' })
                } else {
                  this.$router.push({ name: 'home' })
                }
              }
            })
          } else if (unknownData.length) {
            let unknownDetails= unknownData.map(item => {
              return item.unknownDetails
            }).filter(item => item)
            this.loading = false
            let data = [
              { errorMsg: unknownDetails }
            ]
            this.$emit('errorMsg', data)
          } else if (completedData.length === res.length) {
            this.excel[0].status = 'ready'
            this.loading = false
            if (this.$route.query.isSamplePlate) {
              this.$router.push({ name: 'sample-board-list' })
            } else {
              this.$router.push({ name: 'home' })
            }
          }
        }).catch(err => {
          this.$message.error(err)
        })
      })
    }
  },
  created () {
    this.getOrderWorkFlow()
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-business-order-lot-form {
  :global {
    .el-loading-spinner {
      top: 10%;
    }
  }
  .el-input,
  el-date-editor {
    width: 280px !important;
  }
  .el-upload-list {
    max-width: 800px;
  }
  el-textarea,
  .el-textarea__inner {
    width: 500px;
    font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
  }
  .dashed {
    margin: 30px 0;
    height: 1px;
    background-image: linear-gradient(
      to right,
      #ccc 0%,
      #ccc 50%,
      transparent 50%
    );
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
}
</style>
